<h4 class="tds-u-pl1" >Add Info Message</h4>
<div>
<div class="tds-row tds-u-mb1">
    <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12">
        <tds-datetime
            [(ngModel)]="fromDate"
            ngDefaultControl
            id="datetime"
            defaultValue="{{todaysDate}}"
            type="date"
            size="md"
            state="none"
            label="From date">
        </tds-datetime>
    </div>
    <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-6 tds-col-md-6 tds-col-sm-6 tds-col-xs-12x">
        <tds-datetime
            [(ngModel)]="toDate"
            ngDefaultControl
            id="datetime"
            defaultValue="{{tommorowDate}}"
            type="date"
            size="md"
            state="none"
            label="To date">
        </tds-datetime>
    </div>
    <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12">
        <tds-dropdown
            ngDefaultControl
            name="dropdown"
            label="Select Urgency-level"
            label-position="outside"
            size="md"
            default-value="1"
            open-direction="auto">
                <tds-dropdown-option (click)="urgency='1'" value="1">1 (Important)</tds-dropdown-option>
                <tds-dropdown-option (click)="urgency='2'" value="2">2 (Attention)</tds-dropdown-option>
                <tds-dropdown-option (click)="urgency='3'" value="3">3 (Information)</tds-dropdown-option>
        </tds-dropdown>
    </div>
</div>
</div>
<div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12 tds-u-mb1">
    <tds-textarea
        [(ngModel)]="message"
        ngDefaultControl
        rows="3"
        label="Message"
        label-position="inside"
        placeholder="Enter Text Here...">
    </tds-textarea>
</div>

<div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12 tds-u-mb1">
    <tds-button type="submit" variant="primary" size="lg" [disabled]="isDataNotSet()" text="Submit" (click)="submitData()">
        <tds-icon slot="icon" class="tds-btn-icon" size="20px" name="send"></tds-icon>
    </tds-button>
</div>

<h4 class="tds-u-pl1" *ngIf="infoMessages.length > 0">
    Current Info Messages
</h4>

<div class="tds-u-pl1" style="max-height: 300px; overflow-y: scroll;">
    <tds-table *ngIf="infoMessages.length > 0" vertical-dividers="false" compact-design="true" responsive="true" no-min-width="true">
        <tds-table-header>
            <tds-header-cell column-key="fromDate" column-title="From date"></tds-header-cell>
            <tds-header-cell column-key="toDate" column-title="To Date"></tds-header-cell>
            <tds-header-cell column-key="urgencyLevel" column-title="Urgency"></tds-header-cell>
            <tds-header-cell column-key="message" column-title="Message"></tds-header-cell>
            <tds-header-cell column-key="deleteMessage" column-title="Delete"></tds-header-cell>
            <tds-header-cell column-key="status" column-title="Status"></tds-header-cell>
        </tds-table-header>

        <tds-table-body>
            <tds-table-body-row *ngFor="let msg of infoMessages">
                <tds-body-cell>
                    <div style="white-space:nowrap;">
                        {{toISOString(msg.activateDate)}}
                    </div>
                </tds-body-cell>
                <tds-body-cell>
                    <div style="white-space:nowrap;">
                        {{toISOString(msg.deactivateDate)}}
                    </div> 
                </tds-body-cell>
                <tds-body-cell>
                    {{ msg.header }}
                </tds-body-cell>
                <tds-body-cell>
                    {{ msg.message }}
                </tds-body-cell>
                <tds-body-cell
                    cellValue=""
                    cell-key="deleteMessage">
                        <tds-button type="button" variant="danger" size="sm" text="" (click)="deleteMessage(msg)">
                            <tds-icon slot="icon" class="tds-btn-icon" size="16px" name="trash"></tds-icon>
                        </tds-button>
                </tds-body-cell>
                <tds-body-cell
                    cellValue=""
                    cell-key="status" class="tds-u-pt2">
                        <tds-icon *ngIf="isActive(msg.activateDate)" name="info" size="24px" style="background-color: lightgreen"></tds-icon>
                        <tds-icon *ngIf="!isActive(msg.activateDate)" name="info" size="24px" style="background-color: yellow;"></tds-icon>
                </tds-body-cell>      
            </tds-table-body-row>
        </tds-table-body>
    </tds-table>
</div>